export default "__VITE_ASSET__BrmPxU4H__"